/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    Tablet = "tablet",
    Inventory = "inventory",
};
